module.exports = __webpack_public_path__ + "media/images/scribeconnect_logo-b24a58d7.png";